// Module
var code = "<kform kid=\"$ctrl.kid\" create=\"false\" name=\"formName\" options=\"$ctrl.options\" on-cancel=\"$ctrl.cancel()\" on-submit=\"$ctrl.submit(itemKid)\"></kform> ";
// Exports
export default code;